module.exports = __webpack_public_path__ + "static/media/mini_logo_dark.8de58428.svg";